import { Reducer } from "redux";
import { PartnerActionTypes, PartnerApi } from "../Api/Partner/partnerTypes";

const initialState: PartnerApi | null = null;

export const partnerReducer: Reducer<PartnerApi | null> = (state = initialState, action) => {
	switch (action.type) {
		case PartnerActionTypes.SET: {
			return { ...state, ...action.payload };
		}
		case PartnerActionTypes.CLEAR: {
			return null;
		}
		default: {
			return null;
		}
	}
};
